import { NgModule } from '@angular/core';
import { AboutModule, CommonModule } from 'common';

import { SharedModule } from '../shared/shared.module';
import { AboutPageRoutingModule } from './about-page-routing.module';

@NgModule({
  imports: [
    CommonModule,
    AboutModule,
    SharedModule,
    AboutPageRoutingModule
  ]
})
export class AboutPageModule { }
